import React from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Travel Friends | Not Found</title>
        <meta name="description" content="Not Found page" />
      </Helmet>
      <h1>About page</h1>
    </>
  );
};

export default NotFound;
